module.exports = __webpack_public_path__ + "448f5e9b7b924b705fdba760f4a4b8b8.pdf";